import { NavLink, Outlet } from 'react-router-dom';
import { cn } from '@/lib/cn';

const TABS = [
  { to: '/settings/account', label: 'Account' },
  { to: '/settings/company', label: 'Company' },
  { to: '/settings/team', label: 'Team' },
  { to: '/settings/subscription', label: 'Subscription' },
  { to: '/settings/support', label: 'Support' },
];

export function Settings() {
  return (
    <div className="mx-auto max-w-content-wide px-5 py-gap-group md:px-10 lg:px-20">
      <h1 className="font-display text-h1 font-bold">Settings</h1>
      <div className="mt-gap-group grid gap-gap-element-lg lg:grid-cols-12">
        <nav className="lg:col-span-3">
          <ul className="flex gap-1 overflow-x-auto lg:flex-col">
            {TABS.map((tab) => (
              <li key={tab.to}>
                <NavLink
                  to={tab.to}
                  className={({ isActive }) =>
                    cn(
                      'inline-flex w-full items-center rounded-md px-3 py-2 text-body-sm transition-colors',
                      isActive
                        ? 'bg-accent/10 text-accent'
                        : 'text-text-secondary hover:bg-border/40 hover:text-text-primary',
                    )
                  }
                >
                  {tab.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
        <div className="lg:col-span-9">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
